import apiInstance from "@/api/axiosInstance";

import type {
  AuthMeConfig,
  LoginConfig,
  LoginResponse,
  RequestConfigCreateWithdraw,
  RequestConfigReferralPayments,
  ResponseReferralPayments,
  User,
} from "../types/users.types";

export const authMe = async (config?: AuthMeConfig): Promise<User> => {
  const response = await apiInstance.get<User>(`/auth/me`, config?.config);

  return response.data;
};

export const loginByInitData = (
  config: LoginConfig,
): Promise<LoginResponse> => {
  return apiInstance.post(
    `/auth/login`,
    config.params.initData,
    config?.config,
  );
};

export const CreateWithdraw = async ({
  params,
  config,
}: RequestConfigCreateWithdraw) => {
  const response = await apiInstance.post(
    `/users/create-withdraw-usdt`,
    params,
    config,
  );
  return response.data;
};

export const GetReferralPayments = async ({
  params,
  config,
}: RequestConfigReferralPayments) => {
  const queryParams = new URLSearchParams();
  if (params?.page) {
    queryParams.append("page", params.page.toString());
  }

  if (params?.limit) {
    queryParams.append("limit", params.limit.toString());
  }

  const response = await apiInstance.get<ResponseReferralPayments>(
    `/users/referral-payments?${queryParams.toString()}`,
    {
      signal: config?.signal,
    },
  );
  return response.data;
};
